<template>
  <ul>
    <li v-if="list.minLengthError">
      {{ $t("passwordPolicy.minLengthError") }}:
      <strong>{{ list.minLengthError.minLength }}</strong
      >. {{ $t("passwordPolicy.actualLength") }}:
      <strong>{{ list.minLengthError.length }}</strong
      >.
    </li>
    <li v-if="list.maxLengthError">
      {{ $t("passwordPolicy.maxLengthError") }}:
      <strong>{{ list.maxLengthError.maxLength }}</strong
      >. {{ $t("passwordPolicy.actualLength") }}:
      <strong>{{ list.maxLengthError.length }}</strong
      >.
    </li>
    <li v-if="list.mustContainDigits">
      {{ $t("passwordPolicy.mustContainDigitsError") }}
    </li>
    <li v-if="list.mustContainLowercaseLetters">
      {{ $t("passwordPolicy.mustContainLowercaseLettersError") }}
    </li>
    <li
      v-if="
        list.requiredLowercaseLetters &&
        list.requiredLowercaseLetters.length > 0
      "
    >
      {{ $t("passwordPolicy.requiredLowercaseLettersError") }}:
      <strong>{{ list.requiredLowercaseLetters.join(", ") }}</strong
      >.
    </li>
    <li v-if="list.mustContainUppercaseLetters">
      {{ $t("passwordPolicy.mustContainUppercaseLettersError") }}
    </li>
    <li
      v-if="
        list.requiredUppercaseLetters &&
        list.requiredUppercaseLetters.length > 0
      "
    >
      {{ $t("passwordPolicy.requiredUppercaseLettersError") }}:
      <strong>{{ list.requiredUppercaseLetters.join(", ") }}</strong
      >.
    </li>
    <li v-if="list.mustContainSpecialCharacters">
      {{ $t("passwordPolicy.mustContainSpecialCharactersError") }}
    </li>
    <li v-if="list.invalidSpecialCharsError">
      {{ $t("passwordPolicy.allowedSpecialCharsError") }}:
      <strong>{{ list.invalidSpecialCharsError.invalidChars }}</strong
      >.
    </li>
    <li v-if="list.matchesCurrentOne">
      {{ $t("passwordPolicy.matchesCurrentOneError") }}
    </li>
    <li v-if="list.hasAlreadyBeenUsed">
      {{ $t("passwordPolicy.hasAlreadyBeenUsedError") }}
    </li>
    <li v-if="list.minDifferencePasswordError">
      {{ $t("passwordPolicy.minDifferencePasswordError") }}:
      <strong>{{ list.minDifferencePasswordError.requiredDifference }}</strong>
    </li>
    <li v-if="list.allCharactersMustBeUnique">
      {{ $t("passwordPolicy.allCharactersMustBeUniqueError") }}
    </li>
    <li v-if="list.containSpaces">
      {{ $t("passwordPolicy.containSpacesError") }}
    </li>
    <li v-if="list.containedInBlacklist">
      {{ $t("passwordPolicy.containedInBlacklistError") }}
    </li>
    <li v-if="list.foundInUserData">
      {{ $t("passwordPolicy.foundInUserDataError") }}
    </li>
  </ul>
</template>
  
  <script>
export default {
  name: "PasswordValidationErrors",
  props: {
    list: {
      default: {},
    },
  },
};
</script>